const listAttributes = ['userId', 'karma', 'celebrated'] as const;
const getAttributes = [...listAttributes] as const;
const updateAttributes = ['celebrated'] as const;

export const SlackConfigAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
